export const wednesdayUppercase = "ora";
export default {wednesdayUppercase};